import React from 'react'
import { Route, Switch } from 'react-router'
import { Container } from 'react-bootstrap'
import Home from './home/home'
import Mission from './mission/mission'
import Media from './media/media'
import Profile from './profile/profile'
import Login from './login/login'
import Signup from './signup/signup'
import Survey from './survey/survey'
import RecipesRouter from './recipes/recipeRouter'
import BlogRouter from './blog/BlogRouter'

export default function Public({ match }) {
    const { path } = match
    return (
        
            <Switch>
                <Route exact path={path} component={Home} />    
                <Route exact path={`${path}mission`} component={Mission} />
                <Route exact path={`${path}media`} component={Media} />
                <Route exact path={`${path}profile`} component={Profile} />
                <Route exact path={`${path}login`} component={Login} />
                <Route exact path={`${path}signup`} component={Signup} />
                <Route exact path={`${path}survey`} component={Survey} />
                <Route path={`${path}recipes`} component={RecipesRouter} />
                <Route path={`${path}blog`} component={BlogRouter} />
                
            </Switch>
        
    )
}

